import React, { useState, useEffect } from "react";
import TinyMCEDitor from "../../../ReusableComponents/tinymceEditor";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  MainSource,
  SubMainSource,
} from "../../../ReusableComponents/QBDropdowns";
import { Alert } from "../../../Student/Reusablecomponents/RegularFunctions";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import axios from "axios";
import Loading from "../../../Student/Reusablecomponents/Loading";
import * as Yup from "yup";
import { GetScenarioDetails } from "../../../ReusableComponents/CommonApis";
import axiosInstance from "../../../ReusableComponents/Axios";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import QBCList from "../../../ReusableComponents/QBCheckList";
const FilterScenario = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const updateScenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const [Load, SetLoad] = useState(false);
  const [NTDeatils, SetNTDeatils] = useState(updateScenario?.mainSourceLovId);
  const [NTBased, SetNTBased] = useState(updateScenario?.sSourceId);
  const [AQErrors, SetAQErrors] = useState({});

  const [SCHeckList, SetSCHeckList] = useState();
  // const [SCValues, SetSCValues] = useState();

  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const [GetEditorValue, SetGetEditorValue] = useState(
    updateScenario?.scenarioName
  );
  const [OtherComents, SetOtherComents] = useState(
    updateScenario?.qsOthersComments
  );

  const [TLODetails, SeTLODetails] = useState();

  const GetLOByScenario = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/Scenario/GetLearningOutComesByScenarioId?ScenarioId=${location?.state?.SID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SeTLODetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetLOByScenario();
    // ScenarioCheckList();
  }, []);

  const AddScenario = async () => {
    if (GetEditorValue?.length > 0) {
      SetLoad((prev) => !prev);

      const ScenarioDetails = {
        scenario: GetEditorValue,
        subjectID: items?.subjectId,
        mainSourceLovId: NTDeatils,
        sSourceId: NTBased,
        otherScenarioComments: OtherComents,
        createdBy: items?.userId,
      };
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + `/Scenario/AddScenario`,
          ScenarioDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data === 1) {
            notify("Scenario added successfully", "success");
            navigate(-1);
          } else {
            notify("Scenario already exists", "error");
          }
        })
        .catch((err) => {
          notify("Scenario not added. Please try again", "error");
        });
      SetLoad((prev) => !prev);
    } else {
      notify("Scenario field is required", "warning");
    }
  };
  const EditScenario = async () => {
    SetLoad((prev) => !prev);
    const ScenarioDetails = {
      scenarioID: updateScenario?.scenarioID,
      scenario: GetEditorValue,
      subjectID: items?.subjectId,
      mainSourceLovId: NTDeatils,
      sSourceId: NTBased,
      otherScenarioComments: OtherComents,
      modifiedBy: items?.userId,
      AddScenarioQuestionChecklist: SCValues,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/Scenario/UpdateScenario`,
        ScenarioDetails,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        dispatch(ScenarioData({ ScenarioDetails: "" }));
        notify("Scenario updated successfully", "success");
        navigate(-1);
      })
      .catch((err) => {
        notify("Scenario not updated. Please try again", "error");
      });

    SetLoad((prev) => !prev);
  };
  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    NTDeatils: Yup.string().required("Source is required"),
    GetEditorValue: Yup.string().required("Scenario is required"),
  });
  const Validation = () => {
    const AllFields = { GetEditorValue, NTBased, NTDeatils };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
         SetAQErrors({});
          if (CValidation) {
        if (updateScenario) {
          EditScenario();
        } else {
          AddScenario();
        }
      }})
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        // console.log("newErrors", newErrors);
        SetAQErrors(newErrors);
      });
  };

  // const ScenarioCheckList = async () => {
  //   try {
  //     const res = await axiosInstance.get(
  //       "/Scenario/GetScenarioChecklistQuestions"
  //     );
  //     const Storeids = res.data.map((item, index) => ({
  //       checklistQuestionId: item.checklistQuestionId,
  //       status: parseInt(updateScenario?.status?.[index]) || 0,
  //     }));
  //     SetSCValues(Storeids);
  //     SetSCHeckList(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const StoreCheckList = (id, e) => {
  //   const status = e.target.checked ? 1 : 0;
  //   const Update = SCValues.map((item) =>
  //     item.checklistQuestionId === id ? { ...item, status } : item
  //   );
  //   SetSCValues(Update);
  // };

    const [HitCLV, SetHitCLV] = useState(false);
    const [CValidation, SetCValidation] = useState(false);
      const [SCValues, SetSCValues] = useState();
       useEffect(() => {
          if (CValidation) {
            Validation();
          }
        }, [CValidation]);
  return (
    <>
      <div className="MainHeading">
        {updateScenario ? "Update" : "Add"} Scenario
      </div>
      <Alert />
      <div className="Card mt-2">
        <div className="container-fluid">
          <div className="m-2">
            Scenario Source <span className="text-danger">*</span>
          </div>

          <Row>
            <Col>
              {" "}
              <MainSource
                className="NCLDropdown w-100"
                StoreMSource={SetNTDeatils}
                SOption={NTDeatils}
                onChange={(e) => SetNTDeatils(e)}
                LID={SelectLanguage}
              />{" "}
              {AQErrors?.NTDeatils && (
                <span className="error-message">{AQErrors?.NTDeatils}</span>
              )}
            </Col>
            <Col>
              {" "}
              <SubMainSource
                className="NCLDropdown w-100"
                StoreSMSource={SetNTBased}
                SOption={NTBased}
                PId={NTDeatils}
                onChange={(e) => SetNTBased(e)}
                LID={SelectLanguage}
              />
              {AQErrors?.NTBased && (
                <span className="error-message">{AQErrors?.NTBased}</span>
              )}
              {(NTBased === "3574" || NTBased === "3578") && (
                <input
                  type="text"
                  className=" Search mt-2 p-1 w-100"
                  onChange={(e) => SetOtherComents(e.target.value)}
                  placeholder="Enter Comments"
                />
              )}
            </Col>
          </Row>
          <div className="m-2">
            Scenario <span className="text-danger">*</span>
          </div>

          <div className="container-fluid">
            <Row>
              <Col>
                {" "}
                <TinyMCEDitor
                  onChange={(e) => SetGetEditorValue(e)}
                  PostValue={GetEditorValue}
                />
                {AQErrors?.GetEditorValue && (
                  <span className="error-message">
                    {AQErrors?.GetEditorValue}
                  </span>
                )}
              </Col>
              <Col>
                <div className="NCLDataTable">
                  <table className="Data-Table">
                    <thead>
                      <tr>
                        <th colSpan={4}>Learning Outcome wise Questions</th>
                      </tr>
                      <tr>
                        <th>S.No</th>
                        <th>LO Name</th>
                        <th>Grade</th>
                        <th>No. of Questions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TLODetails?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.learningOutcomes}</td>
                          <td>{item.gradeName}</td>
                          <td>{item.noOfQuestions}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={4}>
                          * Learning outcome mapped to parent scenario
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </div>

          {/* <div className="mt-4">
            <div className="dflex flexd-column">
              <b className="mb-3">Checklist for Scenario Submission</b>
              <span>
                <b> Language, Grammar, and Formatting checks</b>
              </span>
            </div>
            <ol>
              {SCHeckList &&
                SCHeckList?.map((item, index) => (
                  <li className="dflex gap-2 alignitems">
                    {/* to be commented for production *
                    <input
                      type="checkbox"
                      checked={!!SCValues?.[index]?.status}
                      onChange={(e) =>
                        StoreCheckList(item.checklistQuestionId, e)
                      }
                    />
                    {item.checklistQuestion}
                  </li>
                ))}
            </ol>
          </div> */}
          <QBCList Heading="Scenario" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetSCValues} Existinvalues={updateScenario?.status} ExistingId={updateScenario?.checklistQuestionId} LanguageId={SelectLanguage}/>
        </div>
        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button className="Buttons bg-success" onClick={() => {Validation(); SetHitCLV(true);}}>
            {updateScenario ? (
              <>
                Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Scenario)
                </span>{" "}
              </>
            ) : (
              "Save"
            )}{" "}
          </button>
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default FilterScenario;
